import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
  },
  state: {
    user: null,
    // showSidebar:true,
    inner_sidebar: [],
    inner_sidebar_backup: {
      settings: [],
      informations: [],
      groups: [],
      committees: [],
      community: [],
    },
    inner_sidebar_loader: false,
    breadcrumbs: {
      title: "",
      links: [],
    },
    selectedMembers: [],
    selectedCommittees: [],
    selectedItemGroups: [],
    selectedInfoGroupMembers: [],
    members: [],
    committees: [],
    eventtypes: [],
    itemgroup_parent_id: 0,
    eventtype_config: {
      reoccurrences: [
        {
          label: "Iedere", // each
          value: "e_",
          days: true,
        },
        {
          label: "Iedere eerste geselecteerd dag van de maand", // each first {day} of the month
          value: "e_first_month_",
          days: true,
        },
        {
          label: "Iedere tweede geselecteerd dag van de maand", // each second {day} of the month
          value: "e_second_month_",
          days: true,
        },
        {
          label: "Iedere derde geselecteerd dag van de maand", // each third {day} of the month
          value: "e_third_month_",
          days: true,
        },
        {
          label: "Iedere vierde geselecteerd dag van de maand", // each fourth {day} of the month
          value: "e_fourth_month_",
          days: true,
        },
        {
          label: "Iedere laatste geselecteerd dag van de maand", // each last {day} of the month
          value: "e_last_month_",
          days: true,
        },
        {
          label: "Ieder jaar", // each year
          value: "e_year",
          days: false,
        },
      ],
    },
    committee_settings: {
      blocks: [
        [
          { label: "Over", visible: true, order: 2 }, // About
          { label: "Taken", visible: true, order: 1 }, // Tasks
          { label: "Agenda", visible: true, order: 3 }, // Calendar
        ],
        [
          { label: "Nieuws", visible: true, order: 4 }, // News
          { label: "Informatie", visible: true, order: 5 }, // Itemgroups
          { label: "Documenten", visible: true, order: 6 }, // Documents
        ],
      ],
    },
    register: {
      firstname: "",
      lastname: "",
      email: "",
      display_name: "",
      username: "",
      password: "",
      repassword: "",
      toc: false,
    },
  },

  mutations: {
    addUserBreadcrumb(state, user) {
      var title = "";
      if (user.display_name.length > 0) {
        title = user.display_name;
      } else {
        title = user.firstname + "  " + state.auth.user.lastname;
      }

      state.breadcrumbs.links.push({
        title: title,
        href: "/profile/" + user.id + "/view",
      });
    },
    addBreadcrumb(state, crumb) {
      state.breadcrumbs.links.push(crumb);
    },
    addSelectedMembers(state, obj) {
      state.selectedMembers.push(obj);
    },
    addSelectedInfoGroupMembers(state, obj) {
      state.selectedInfoGroupMembers.push(obj);
    },
    addSelectedItemgroup(state, obj) {
      state.selectedItemGroups.push(obj);
    },
    addSelectedCommittees(state, obj) {
      state.selectedCommittees.push(obj);
    },
    // setUserData (state, userData) {
    //   state.user = userData
    //   localStorage.setItem('user', JSON.stringify(userData))
    //   axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`
    // },

    // clearUserData () {
    //   localStorage.removeItem('user')
    //   location.href='/';
    // }
  },

  actions: {
    // async login ({ commit }, credentials){
    //   console.log(credentials);
    //   await axios.get('/sanctum/csrf-cookie');
    //   return axios
    //     .post('/api/login', credentials)
    //     .then(({ data }) => {
    //       console.log(data);
    //       commit('setUserData', data)
    //     }).
    //     catch((error)=>{
    //       console.log(error.request);
    //     });
    // },
    // async logout ({ commit }){
    //   await axios.post('/api/logout')
    //   .catch((error)=>{
    //     console.log(error.request);
    //   });
    //   commit('clearUserData');
    // },
    postMail(context, data) {
      context.commit("auth/loader", true);
      context
        .dispatch("post", { endpoint: "/api/v1/emails", details: data })
        .then(() => {
          context.dispatch("auth/makeNotification", {
            status: "Email",
            statusText: "Email verzonden",
          });
          context.commit("auth/loader", false);
        })
        .catch((error) => {
          context.dispatch("auth/processError", error);
          context.commit("auth/loader", false);
        });
    },
    post(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(data.endpoint, data.details)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            context.dispatch("auth/processError", error);
            reject(error);
          });
      });
    },
    put(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(data.endpoint, data.details)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            context.dispatch("auth/processError", error);

            reject(error);
          });
      });
    },
    get(context, endpoint) {
      return new Promise((resolve, reject) => {
        axios
          .get(endpoint)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    delete(context, endpoint) {
      return new Promise((resolve, reject) => {
        axios
          .delete(endpoint)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },

  getters: {
    isLogged: (state) => !!state.user,
    userRoles: (state) => (state.auth.user ? state.auth.user.roles : []),
    userPermissions: (state) =>
      state.auth.user ? state.auth.user.permissions : [],
    userCommittees: (state) =>
      state.auth.user ? state.auth.user.user_committees : [],
    userPermissionsName: (state, getters) => {
      let permissions = [];

      getters.userPermissions.forEach((item) => {
        permissions.push(item.name);
      });

      getters.userRoles.forEach((role) => {
        role.permissions.forEach((perm) => {
          if (!permissions.includes(perm.name)) {
            permissions.push(perm.name);
          }
        });
      });

      getters.userCommittees.forEach((committee) => {
        committee.permissions.forEach((perm) => {
          if (!permissions.includes(perm.name)) {
            permissions.push(perm.name);
          }
        });
      });

      return permissions;
    },
    userRolesName: (state, getters) => {
      let roles = [];

      getters.userRoles.forEach((item) => {
        roles.push(item.name);
      });

      return roles;
    },
    register(state) {
      return state.register;
    },
  },
});
